import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import AssignmentIcon from '@material-ui/icons/Assignment';

export const rootRouteRef = createRouteRef();

const requestsPage = PageBlueprint.make({
  params: {
    path: '/spoke-requests',
    title: 'All Requests',
    icon: <AssignmentIcon fontSize="inherit" />,
    routeRef: rootRouteRef,
    loader: async () => {
      const { SpokeRequestsPage } = await import('./pages/SpokeRequestsPage');
      return <SpokeRequestsPage />;
    },
  },
});

export const spokeRequestsPlugin = createFrontendPlugin({
  pluginId: 'spoke-requests',
  extensions: [requestsPage],
});
